<template>
  <div class="page_all">
    <div class="return_link">
      <router-link to="/pushNotificationTraining">＞ 訓練</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="this.changeFlg" class="title">訓練の編集</div>
        <div v-else class="title">訓練の追加</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button :disabled="$v.$invalid || this.updating" v-if="this.changeFlg" class="btn_general" v-on:click="trainingUpdate()">更新</button>
        <button :disabled="$v.$invalid || this.updating" v-else class="btn_general" v-on:click="trainingAdd()">追加</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_training">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content">
              <div class="index_name">訓練名</div>
              <div><input v-model.trim="$v.trainingName.$model" type="text" class="training_input"/></div>
              <div class="message">
                <div v-if="$v.trainingName.$dirty">
                  <div class="error" v-if="!$v.trainingName.required">訓練名は必須入力です。</div>
                  <div class="error" v-if="!$v.trainingName.maxLength">訓練名は{{ $v.trainingName.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
export default {
  data: function() {
    return {
      trainingId: "",
      trainingName: "",
      // 変更フラグ
      changeFlg: false,
      // メッセージ
      message: "",
      updating: false,
    }
  },
	mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // 変更の場合はStoreから設定
    if (this.changeFlg) {
      this.trainingId = this.$store.getters.getStatePushTrainingId
      this.trainingDetail()
    }
  },
  methods: {
    async trainingDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'push-training/detail', {
          params: {
            training_id: this.trainingId
          }
        })
        this.trainingName = response.data[0].name
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async trainingAdd() {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'push-training/add', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          training_name: this.trainingName,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.$router.push('/pushNotificationTraining')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    async trainingUpdate() {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'push-training/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          push_training_id: this.trainingId,
          push_training_name: this.trainingName,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.$router.push('/pushNotificationTraining')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    }
  },
  validations: {
    trainingName: {
      required,
      maxLength: maxLength(50)
    }
  }
}
</script>

<style scoped>
.tbl_main {
  background-color: white;
}
table th.th_training {
  text-align: left;
  padding-left: 10px;
}
.td_content {
  text-align: left;
  padding: 20px 20px 0px 20px;
}
.index_name {
  padding: 0px 0px 5px 0px;
}
.training_input {
  width: 758px;
}
</style>